import { storeConfig } from "../config/store-config/store.config";

export const useStoreConfig = () => storeConfig;
